import React from 'react';
import Select from '../../commonComponents/util/Select';

export default class CampaignsFilters extends React.Component {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange(event) {
        this.props.update({ [event.target.name]: event.target.value });
    }

    render() {
        return (
            <div className="campaigns-filters">
                <div className="container flex-center">
                    <Select clearable={true} name="categoryId" value={this.props.categoryId} placeholder="Category"
                        options={this.props.campaignSettings.categories.map(cat => ({ key: cat.campaignCategoryId, value: cat.name }))} onChange={this.onChange} />
                    <Select clearable={true} name="locationId" value={this.props.locationId} placeholder="Location"
                        options={this.props.campaignSettings.locationGroups.map(locationGroup =>
                            ({
                                key: locationGroup.groupId,
                                value: locationGroup.groupName,
                                details: locationGroup.members.map(member => `${member.city}, ${member.state}`).join('\n')
                            }))}
                        onChange={this.onChange} />
                    <Select clearable={true} name="year" value={this.props.year} placeholder="Year"
                        options={this.props.campaignSettings.years.sort((y1, y2) => y2 - y1).map(yr => ({ key: yr, value: yr }))} onChange={this.onChange} />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaigns/CampaignsFilters.jsx